module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "header-logo"
  }, [_vm._v("\n  CallMeWeb\n")])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0a0b95c1","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Panel/HeaderContainer/HeaderLogo/index.vue
// module id = 718
// module chunks = 3